import { render, staticRenderFns } from "./AceVue.vue?vue&type=template&id=4275c99f&scoped=true&"
import script from "./AceVue.vue?vue&type=script&lang=js&"
export * from "./AceVue.vue?vue&type=script&lang=js&"
import style0 from "./AceVue.vue?vue&type=style&index=0&id=4275c99f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4275c99f",
  null
  
)

export default component.exports